import React from "react";
import {
  Container,
  Box,
  Grid,
  Divider,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActionArea,
  CardActions,
  Badge,
  Tooltip,
  Button,
  Skeleton,
} from "@mui/material";
import { Scale, WorkHistory, WorkspacePremium } from "@mui/icons-material";
import { useSelector } from "react-redux";

const Skills = () => {
  const { developer, developers, pending } = useSelector(
    (state) => state.developers
  );
  const { attributes, home, skills } = developer;
  return (
    <>
      <Container maxWidth="md">
        <Box sx={{ pb: 5 }}>
          <Box sx={{ pb: 3 }}>
            <Typography variant="h3">Skills</Typography>
            <Typography variant="h5">
              {" "}
              These are the technologies i've worked with
            </Typography>
          </Box>
          <Box>
            <Grid container spacing={2}>
              {skills?.length > 0 ? (
                skills?.map((skill) => {
                  const { attributes } = skill;
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={4}>
                      <Card sx={{ maxWidth: 345 }}>
                        {!pending ? (
                          <CardMedia
                            component="img"
                            height="140"
                            image={`${attributes?.logo}`}
                            alt="green iguana"
                          />
                        ) : (
                          <Skeleton
                            animation="wave"
                            variant="rectangular"
                            width={345}
                            height={125}
                          />
                        )}
                        <CardContent>
                          {!pending ? (
                            <Typography
                              gutterBottom
                              variant="h5"
                              component="div"
                            >
                              {attributes?.type}
                              <WorkspacePremium color="action" />
                            </Typography>
                          ) : (
                            <Skeleton animation="wave" height={50} p={2} />
                          )}
                          {!pending ? (
                            <Typography variant="body2" color="text.secondary">
                              {attributes?.skill}
                            </Typography>
                          ) : (
                            <Skeleton animation="wave" height={50} p={2} />
                          )}
                        </CardContent>
                        <CardActions>
                          {!pending ? (
                            <Button
                              // href={`${attributes?.type}`}
                              size="small"
                            >
                              {attributes?.experience} Years Of Experience
                            </Button>
                          ) : (
                            <Skeleton
                              animation="wave"
                              height={50}
                              p={2}
                              width="100%"
                            />
                          )}
                          {!pending ? (
                            <Button
                              // href={`${attributes?.experience}`}
                              size="small"
                            >
                              <WorkHistory color="action" />

                              {attributes?.experience}
                            </Button>
                          ) : (
                            <Skeleton
                              animation="wave"
                              height={50}
                              p={2}
                              width="100%"
                            />
                          )}
                        </CardActions>
                      </Card>
                    </Grid>
                  );
                })
              ) : (
                <Skeleton animation="wave" height={500} width="100%" />
              )}
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Skills;
